import { render } from "./F2Component.vue?vue&type=template&id=7fb93118&ts=true"
import script from "./F2Component.vue?vue&type=script&lang=ts"
export * from "./F2Component.vue?vue&type=script&lang=ts"

import "./F2Component.vue?vue&type=style&index=0&id=7fb93118&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__